module.exports = __webpack_public_path__ + "img/B556.52c26933.jpg";